// extracted by mini-css-extract-plugin
module.exports = {"slickList":"PopupSupport_slickList__mYpcl"};